"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = exports.AvatarSize = void 0;
var React = require("react");
var avatar_1 = require("wix-ui-core/dist/src/components/avatar");
var Avatar_st_css_1 = require("./Avatar.st.css");
var Anonymous_svg_1 = require("../../assets/icons/Anonymous.svg");
var AvatarSize;
(function (AvatarSize) {
    AvatarSize["xLarge"] = "xLarge";
    AvatarSize["large"] = "large";
    AvatarSize["medium"] = "medium";
    AvatarSize["small"] = "small";
    AvatarSize["xSmall"] = "xSmall";
    AvatarSize["xxSmall"] = "xxSmall";
})(AvatarSize = exports.AvatarSize || (exports.AvatarSize = {}));
/** Avatar is a type of element that visually represents a user, either as an image, placeholder or text (name initials). */
var Avatar = /** @class */ (function (_super) {
    __extends(Avatar, _super);
    function Avatar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Avatar.prototype.render = function () {
        var _a = this.props, size = _a.size, src = _a.src, name = _a.name, onLoad = _a.onLoad, className = _a.className;
        return (React.createElement(avatar_1.Avatar, { className: Avatar_st_css_1.st(Avatar_st_css_1.classes.root, { size: size }, className), imgProps: src ? { src: src, onLoad: onLoad } : undefined, placeholder: React.createElement(Anonymous_svg_1.ReactComponent, { height: Avatar.dimmentionBySize[size], width: Avatar.dimmentionBySize[size] }), name: name && name.split(' ')[0], "data-hook": this.props['data-hook'] }));
    };
    Avatar.displayName = 'Avatar';
    Avatar.defaultProps = {
        size: AvatarSize.medium,
    };
    Avatar.dimmentionBySize = (_a = {},
        _a[AvatarSize.xLarge] = 60,
        _a[AvatarSize.large] = 52,
        _a[AvatarSize.medium] = 36,
        _a[AvatarSize.small] = 28,
        _a[AvatarSize.xSmall] = 20,
        _a[AvatarSize.xxSmall] = 16,
        _a);
    return Avatar;
}(React.Component));
exports.Avatar = Avatar;
//# sourceMappingURL=Avatar.js.map